/**
 * Configuration for Matomo test user filtering
 */

// Internal email domains that should be treated as test users
const TEST_USER_DOMAINS = [
	"@battmobility.be",
	"@battmobiel.be",
	"@mobilityos.io",
] as const;

/**
 * Check if test users should be filtered (production only)
 */
export function shouldFilterTestUsers(): boolean {
	return import.meta.env.MODE === "production";
}

/**
 * Get list of email domains to filter
 */
export function getTestUserDomains(): ReadonlyArray<string> {
	return TEST_USER_DOMAINS;
}
